var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-body"},[_c('CardList',{staticClass:"-margin-m-",attrs:{"card-list":_vm.cardList,"loading":_vm.isGroupLoading}}),_c('TeamTable',{attrs:{"nav-titles":_vm.navTitles}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }